<template>
  <div>
    <Loading :isLoading="this.isLoading"/>
    <div style="margin-top:30px;">
      <ReedirectButton />
    </div>
    <FilterButtons ref="filterButtonsComponent" :list_to_filter="requests" statusToFilterInPendingButton="documento_cargado" 
      statusToFilterInAcceptedButton="aceptado" statusToFilterInRejectedButton="rechazado" v-on:filter-list-by-status="getRequestsFiltered($event)" />
    <div style="clear: both;"></div>
    <div style="margin-top:30px;" id="pendingRequest">
      <div>
        <p style="text-align:left;font-size:24px;color: #6B6969;font-weight:bold;font-family:Roboto;">{{descriptionText}}</p>
      </div>
      <div class="flex" style="margin-top:30px;">
        <SearchByRfc ref="searchByRfcComponent" :list_to_filter="requests"
          v-on:filter-info-by-rfc="getListFilteredByRfc($event)" />
      </div>
      <div class="flex" style="margin-top:30px;" v-if="requests_filtered.length <= 0">
        <p class="description">No se encontraron registros</p>
      </div>
      <table class="table tableRequests" id="table-id" style="margin-top:20px;">
        <thead>
          <tr>
            <th>
              #
            </th>
            <th v-on:click="sortTable('rfc')">
              <div class="grid grid-cols-2">
                <div>
                  RFC
                </div>
                <div>
                  <div class="arrow" v-if="'rfc' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-on:click="sortTable('name')">
              <div class="grid grid-cols-2">
                <div>
                  NOMBRE
                </div>
                <div>
                  <div class="arrow" v-if="'name' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-on:click="sortTable('email')">
              <div class="grid grid-cols-2">
                <div>
                  EMAIL
                </div>
                <div>
                  <div class="arrow" v-if="'email' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th>
              BENEFICIARIOS
            </th>
            <th>
              FECHA DE REGISTRO
            </th>
            <th v-if="statusFilter != 'aceptado'"></th>
            <th v-if="statusFilter != 'rechazado'"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in requests_filtered" :key="item.id">
            <td>{{index+1}}</td>
            <td>{{item.rfc | capitalize}}</td>
            <td>{{item.name | camelize}} {{item.paternal_name | camelize}} {{item.maternal_name | camelize}}</td>
            <td>{{item.email}}</td>
            <td>
              {{item.beneficiaries_list_json.map(b => `${b.name} ${b.paternal_name} ${b.maternal_name}`).join(', ') | camelize}}
            </td>
            <td>{{item.created_at | moment}}</td>
            <td style="padding-left:0px;"><input type="button" value="Ver documento" class="buttonGrey" v-on:click="downloadDocument(item.id)" /></td>
            <td v-if="statusFilter != 'aceptado'" style="padding-left:0px;"><input type="button" class="acceptRequest" value="Aceptar" id="button_accept" v-on:click="acceptRequest(item)" /></td>
            <td v-if="statusFilter == 'documento_cargado'" style="padding-left:0px;"><input type="button" class="rejectRequest" value="Rechazar" id="button_reject" v-on:click="rejectRequest(item)" /></td>
          </tr>
        </tbody>
      </table>
      <div v-show="requests_filtered.length > elementsPerPage" class='pagination-container' style="text-align:center;">
        <nav>
          <ul class="pagination pagination-requests">
            <li data-page="prev" style="cursor: pointer;">
              <span>Anterior<span class="sr-only">(current)</span></span>
            </li>
            <li data-page="next" id="prev" style="cursor: pointer;">
              <span>Siguiente<span class="sr-only">(current)</span></span>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="form-group" style="visibility:hidden"> 	<!--		Show Numbers Of Rows 		-->
      <select class ="form-control" name="state" id="maxRows">
        <option value="5000">Show ALL Rows</option>
        <option value="5">5</option>
      </select>
    </div>
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css">
  </div>
</template>

<script>
import('@/assets/css/stylesheet.css')

import User from '@/classes/User'
import Beneficiarie from '@/classes/Beneficiarie'
import Swal from 'sweetalert2'

import Loading from '@/components/Loading/Loading.vue'
import ReedirectButton from '@/components/Forms/ReedirectButton.vue'
import FilterButtons from '@/components/FilterButtons/FilterButtons.vue'
import SearchByRfc from '@/components/Search/SearchByRfc.vue'

import { getPagination, filterByStatus } from '@/helpers/tablePagination'
import { descriptionRequestText } from '@/helpers/enums'
import {sendMailNotificationClient, bodyEmailNotificationClient} from '@/helpers/email'

export default {
  data() {
    return{
      token_auth: "",
      userObjectClass: null,
      beneficiarieObjectClass: null,
      elementsPerPage: 10,
      statusFilter: "documento_cargado",
      activeColorBackground: '#198F99',
      inactiveColorBackground: '#FFF',
      activeColorText: '#FFF',
      inactiveColorText: '#6B6969',
      activeBorderColor: "#198F99",
      inactiveBorderColor: "#6B6969",
      sortColumn: "",
      ascending: false,
      requests: [],
      requests_filtered: [],
      isLoading: false,
      rfc: "",
      descriptionText: "Solicitudes Pendientes",
      userFas: process.env.VUE_APP_USER_FAS,
      passwordFas: process.env.VUE_APP_PASSWORD_FAS,
    }
  },
  name: "BeneficiarieUpdateRequestsComponent",
  components: {
    Loading,
    ReedirectButton,
    FilterButtons,
    SearchByRfc
  },
  mounted() {
    this.userObjectClass = new User();
    this.beneficiarieObjectClass = new Beneficiarie();
    this.login();
  },
  methods: {
    getRequestsFiltered(event) {
      this.statusFilter = event.status;
      this.changeDescriptionText(event.status);
      this.setBeneficiarieUpdateRequestFiltered(event.data).then(response => {
        getPagination("#table-id", ".pagination-requests", "#prev", "#maxRows", this.elementsPerPage, this.requests_filtered.length);
      });
    },
    login() {
      this.isLoading = true;
      this.userObjectClass.login(this.userFas, this.passwordFas).then(response => {
        this.isLoading = false;
        this.token_auth = response.data.token_auth;
        this.getAllRequest().then(response => {
          this.$refs.filterButtonsComponent.filterByStatus(this.statusFilter);
        });
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    changeDescriptionText(buttonSelected) {
      this.descriptionText = descriptionRequestText[buttonSelected];
    },
    async setBeneficiarieUpdateRequestFiltered(requestFiltered) {
      this.requests_filtered = requestFiltered;
    },
    getAllRequest() {
      return this.beneficiarieObjectClass.getAllRequest(this.token_auth).then(response => {        
        this.requests = response.data.response.data;
        console.log(this.requests);
        return response;
      }).catch(error => {
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    sortTable(col) {
      if (this.sortColumn === col) {
        this.ascending = !this.ascending;
      } else {
        this.ascending = true;
        this.sortColumn = col;
      }

      var ascending = this.ascending;

      this.requests_filtered.sort(function(a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0;
      })
    },
    acceptRequest(beneficiarie) {
      Swal.fire({
        title: "Aviso",
        customClass: {
          container: 'my-swal'
        },
        text: "¿Desea aceptar la solicitud?",
        html: `<p style="font-size:18px;">¿Desea aceptar la solicitud de <span style="font-weight:bold;">
          ${this.camelize(beneficiarie.name)} ${this.camelize(beneficiarie.paternal_name)} ${this.camelize(beneficiarie.maternal_name)}</span>?</p>`,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      })
      .then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.beneficiarieObjectClass.acceptRequest(this.token_auth, beneficiarie.id).then(response => {
            let bodyEmail = bodyEmailNotificationClient("Confirmación de Solicitud",`Su Solicitud de Actualización de Beneficiarios ha sido aceptada.`, 'http://200.92.206.58:90/beneficiaries/capture-beneficiaries');

            sendMailNotificationClient(beneficiarie.email, "Notificación Solicitud Actualización de Beneficiarios", bodyEmail, "").then(response =>{
              this.isLoading = false;
              this.getAllRequest().then(response => {
                this.$refs.filterButtonsComponent.filterByStatus(this.statusFilter);
              });
              Swal.fire({
                text: "Solicitud de Actualización de Beneficiarios guardada correctamente",
                html: `<p style="font-size:18px;font-weight:bold;">Solicitud de Actualización de Beneficiarios aceptada correctamente</p>`,
                confirmButtonText: "Continuar",
                allowOutsideClick: false,
                icon: "success",
              })
            }).catch(error => {
              this.isLoading = false;
              Swal.fire({
                title: "Aviso",
                text: error,
                icon: "warning",
              })
            });
          }).catch(error => {
            this.isLoading = false;
            Swal.fire({
              title: "Aviso",
              text: error,
              icon: "error",
            })
          });
        }
      });
    },
    rejectRequest(beneficiarie) {
      Swal.fire({
        title: "Aviso",
        customClass: {
          container: 'my-swal'
        },
        text: "¿Desea rechazar la solicitud?",
        html: `<p style="font-size:18px;">¿Desea rechazar la solicitud de <span style="font-weight:bold;">
          ${this.camelize(beneficiarie.name)} ${this.camelize(beneficiarie.paternal_name)} ${this.camelize(beneficiarie.maternal_name)}</span>?</p>`,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      })
      .then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.beneficiarieObjectClass.rejectRequest(this.token_auth, beneficiarie.id).then(response => {
            let bodyEmail = bodyEmailNotificationClient("Confirmación de Solicitud",`Su Solicitud de Actualización de Beneficiarios ha sido rechazada.`, 'http://200.92.206.58:90/beneficiaries/capture-beneficiaries');

            sendMailNotificationClient(beneficiarie.email, "Notificación Solicitud Actualización de Beneficiarios", bodyEmail, "").then(response =>{
              this.isLoading = false;
              this.getAllRequest().then(response => {
                this.$refs.filterButtonsComponent.filterByStatus(this.statusFilter);
              });
              Swal.fire({
                text: "Solicitud de Actualización de Beneficiarios guardada correctamente",
                html: `<p style="font-size:18px;font-weight:bold;">Solicitud de Actualización de Beneficiarios rechazada correctamente</p>`,
                confirmButtonText: "Continuar",
                allowOutsideClick: false,
                icon: "success",
              })
            }).catch(error => {
              this.isLoading = false;
              Swal.fire({
                title: "Aviso",
                text: error,
                icon: "warning",
              })
            }); 
          }).catch(error => {
            this.isLoading = false;
            Swal.fire({
              title: "Aviso",
              text: error,
              icon: "error",
            })
          });
        }
      });
    },
    downloadDocument(beneficiary_update_request_id){
      var url = process.env.VUE_APP_CCAPI+"/fas/beneficiary_update_request/get_document?token_auth="+this.token_auth+"&beneficiary_update_request_id="+beneficiary_update_request_id
      window.open(url,'_blank');
    },
    camelize(value) {
      if (value != "" && value != undefined) {
        let response = "";
        value = value.toLowerCase().replace(/(?:(^.)|([-_\s]+.))/g, function(match) {
          return match.charAt(match.length-1).toUpperCase();
        });
        response = value.charAt(0).toUpperCase() + value.substring(1);
        return response.replace(/([A-Z])/g, ' $1').trim(); 
      }

      return "";
    },
    getListFilteredByRfc(event) {
      console.log("filter by rfc: ", event);
      let requestFilteredByStatus = filterByStatus(event, 'status', this.statusFilter);
      this.setBeneficiarieUpdateRequestFiltered(requestFilteredByStatus).then(response => {
        getPagination("#table-id", ".pagination-requests", "#prev", "#maxRows", this.elementsPerPage, this.requests_filtered.length);
      });
    },
    reedirect(path) {
      this.isLoading = true;
      window.location = path;
    },
  }
}
</script>